<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const email = ref('')
const password = ref('')

async function handleSubmit() {
  try {
    await authStore.login(email.value, password.value)
  } catch {
    // error is set in store
  }
}
</script>

<template>
  <form class="login-form" @submit.prevent="handleSubmit">
    <h2 class="login-title">Iniciar sesión</h2>

    <div class="field">
      <label for="email">Correo electrónico</label>
      <input
        id="email"
        v-model="email"
        type="email"
        placeholder="tu@correo.com"
        required
        autocomplete="email"
      />
    </div>

    <div class="field">
      <label for="password">Contraseña</label>
      <input
        id="password"
        v-model="password"
        type="password"
        placeholder="Tu contraseña"
        required
        autocomplete="current-password"
      />
    </div>

    <p v-if="authStore.error" class="error-text">Correo o contraseña inválidos</p>

    <button type="submit" class="btn-cta login-btn" :disabled="authStore.isLoading">
      {{ authStore.isLoading ? 'Cargando...' : 'Iniciar sesión' }}
    </button>

    <p class="signup-link">
      ¿No tienes cuenta? <a href="https://korusai.co/es/demo" target="_blank" rel="noopener">Solicitar acceso</a>
    </p>
  </form>
</template>

<style scoped>
.login-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding: var(--space-lg);
  width: 100%;
  max-width: 320px;
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.login-title {
  font-size: 18px;
  font-weight: 500;
  color: var(--korus-navy);
  text-align: center;
  margin-bottom: var(--space-xs);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field label {
  font-size: 13px;
  font-weight: 500;
  color: var(--color-text-light);
}

.login-btn {
  margin-top: var(--space-sm);
  padding: 12px var(--space-md);
  font-size: 14px;
  font-weight: 600;
  width: 100%;
}

.error-text {
  color: var(--color-error);
  font-size: 13px;
  text-align: center;
}

.signup-link {
  font-size: 12px;
  color: var(--color-text-light);
  text-align: center;
}

.signup-link a {
  color: var(--evidence-sky);
  text-decoration: none;
  font-weight: 500;
}

.signup-link a:hover {
  text-decoration: underline;
}
</style>
